import { lazy } from "react";

export const Payments = lazy(() => import("./PanelPages/Payments/Payments"));

export const EditPlan = lazy(() => import("./PanelPages/Plans/EditPlan"));
export const NewPlan = lazy(() => import("./PanelPages/Plans/NewPlan"));
export const Plans = lazy(() => import("./PanelPages/Plans/Plans"));

export const Profile = lazy(() => import("./PanelPages/Profile/Profile"));
export const SignOut = lazy(() => import("./PanelPages/SignOut/SignOut"));

export const Institutions = lazy(
  () => import("./PanelPages/Institutions/Institutions"),
);
export const NewInstitutions = lazy(
  () => import("./PanelPages/Institutions/NewInstitutions"),
);
export const SeeInstitution = lazy(
  () => import("./PanelPages/Institutions/SeeInstitution"),
);

export const UpdateInstitution = lazy(
  () => import("./PanelPages/Institutions/UpdateInstitution"),
);

export const NewUser = lazy(() => import("./PanelPages/Users/NewUser"));
export const Users = lazy(() => import("./PanelPages/Users/Users"));
export const SeeUser = lazy(() => import("./PanelPages/Users/SeeUser"));

export const Panel = lazy(() => import("./PanelPages/Panel/Panel"));

export const Home = lazy(() => import("./PublicPages/Home/Home"));

export const MyInstitutions = lazy(
  () => import("./PanelPages/MyInstitution/MyInstitutions"),
);

export const MyDashboard = lazy(
  () => import("./PanelPages/MyInstitution/MyDashboard"),
);

export const MyQuotas = lazy(
  () => import("./PanelPages/MyInstitution/MyQuotas"),
);

export const MyUsers = lazy(() => import("./PanelPages/MyInstitution/MyUsers"));
export const SeeMyUser = lazy(
  () => import("./PanelPages/MyInstitution/SeeMyUser"),
);
export const MyAdmins = lazy(
  () => import("./PanelPages/MyInstitution/MyAdmins"),
);
export const MyPlan = lazy(() => import("./PanelPages/MyInstitution/MyPlan"));
export const MyPaymens = lazy(
  () => import("./PanelPages/MyInstitution/MyPaymens"),
);
export const MySports = lazy(
  () => import("./PanelPages/MyInstitution/MySports"),
);

export const SeeMyInstitution = lazy(
  () => import("./PanelPages/MyInstitution/SeeMyInstitution"),
);

export const SportsPublic = lazy(() => import("./PublicPages/SportsPublic"));
export const InstitutionsPublic = lazy(
  () => import("./PublicPages/InstitutionsPublic"),
);
export const HelpPublic = lazy(() => import("./PublicPages/HelpPublic"));
export const ManageSports = lazy(
  () => import("./PanelPages/ManageSports/ManageSports"),
);
